import React from "react";

// OTHER ADS
const otherAds = [
  "/image1.jpeg",
  "/image2.jpeg",
];

// LINKS
const redirectUrl =
  "https://sriadityadevelopers.com";

function App() {
  return (
    <div className="App">
      <div className="image-list-container">



        {/* ===== OTHER ADS SECTION ===== */}
        <section className="ad-section other-section">
          <h2 className="section-title">ADS BY SRI ADITYA DEVELOPERS</h2>

          {otherAds.map((src, idx) => (
            <div className="image-item" key={idx}>
              <a
                href={redirectUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={src}
                  alt={`Developer Ad ${idx + 1}`}
                  className="clickable-image"
                />
              </a>
            </div>
          ))}
        </section>

      </div>
    </div>
  );
}

export default App;

